import React from 'react';
import { useRouter } from 'next/router';
import AssociatedContentItem from './AssociatedContentItem';
import AssociatedContentSection from './AssociatedContentSection';
import MissingContent from '../../../../ui-components/MissingContent/MissingContent';
import { SectionContainer } from './AssociatedContent.styles';

export const isSectionDefaultExpanded = (routerQuery, section, selectedVideoId) => {
    return (
        routerQuery.tab === section.id ||
        section.items.some(({ item }) => item.videoSvtId === selectedVideoId) ||
        section.selectionType === 'upcoming'
    );
};

const AssociatedContent = ({ sections, selectedVideoId, progress }) => {
    const router = useRouter();

    return (
        <SectionContainer>
            {sections && sections.length ? (
                sections.map((section, i) => {
                    const isUpcoming = section.id === 'upcoming';
                    const defaultExpanded = isSectionDefaultExpanded(router.query, section, selectedVideoId);
                    const maxItems = isUpcoming ? 1 : 10;

                    return (
                        <AssociatedContentSection
                            key={section.id}
                            name={section.name}
                            defaultExpanded={defaultExpanded}
                            id={section.id}
                            max={maxItems}
                        >
                            {section.items.map((content, i) => (
                                <AssociatedContentItem
                                    key={`associated-${i}`}
                                    content={content}
                                    type={section.id}
                                    selectedVideoId={selectedVideoId}
                                    progress={progress}
                                />
                            ))}
                        </AssociatedContentSection>
                    );
                })
            ) : (
                <MissingContent />
            )}
        </SectionContainer>
    );
};

export default AssociatedContent;
